export default "__VITE_ASSET__Djd7DzRW__"